import { Component, OnInit } from '@angular/core';

import { ConfirmationService, MessageService } from 'primeng/api';



@Component({
  selector: 'app-users',
  templateUrl: './users.component.html',
  styleUrl: './users.component.scss',
  providers: [MessageService, ConfirmationService]
})
export class UsersComponent implements OnInit {

  
  constructor(
  
  ) { }

  ngOnInit(): void {
 
    

  }

  
  
}


